import { useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { ProjectState } from "../../planning/Project";
import { CircularProgress, IconButton, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowForward } from "@mui/icons-material";
import EnhancedTable from "@/shared/views/EnhancedTable";
import ApiService from "@/api/ApiService";
import { usePersistantStore } from "@/stores/global";

const headCells = [
  {
    id: "number",
    label: "Kostenstelle",
    numeric: true,
    sortable: true,
  },
  {
    id: "name",
    label: "Name",
    numeric: false,
    sortable: true,
  },
];

export default function ProjectList({ type }) {
  const navigate = useNavigate();

  const region = usePersistantStore((store) => store.region);

  const filter = !!region ? { region: ["region", region], active: true } : { active: true };

  const query = useQuery<ProjectState[], AxiosResponse>({
    queryKey: ["getProjects", type === "user" ? "user" : filter],
    queryFn: type === "user" ? ApiService.getMyProjects() : ApiService.getEntitiesWithFilter("project", filter, "calendar"),
  });

  return (
    <div style={{ display: "flex", flex: 1, overflow: "auto", justifyContent: "center", alignItems: "center" }}>
      {query.isError ? (
        "Error"
      ) : query.isLoading ? (
        <CircularProgress />
      ) : (query?.data?.length ?? 0) === 0 ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 4, alignSelf: "center", color: "#444", flex: 1 }}>
          <div>Nichts gefunden</div>
        </Box>
      ) : (
        <EnhancedTable
          sx={{ flex: 1, alignSelf: "stretch" }}
          initialSortDir={"asc"}
          initialRows={10}
          initialSort={"name"}
          rows={query.data}
          filter
          headCells={headCells}
          buttons={(r) => (
            <IconButton onClick={() => navigate("/project/" + r.id)}>
              <ArrowForward />
            </IconButton>
          )}
        />
      )}
    </div>
  );
}
